export interface OptoutParam {
  optOut: boolean;
  category: string;
}
